import ReactDOM from "react-dom/client";
import App from "./containers/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
